import UIFlex, { copyFlex, IUIFlexProps } from './UIFlex';
import './UIForm.scss';

export interface IUIFormProps extends IUIFlexProps{
    
}

export function UIForm($props:IUIFormProps){
    let flex = copyFlex({elementType:UIFlex.TYPE_FORM, wrap:true,},$props.flex);

    let cn:string = "form";
    if($props.className){
        cn+=" "+$props.className;
    }
    return (        
        <UIFlex className={cn} flex={flex}>
            {$props.children}
        </UIFlex>
    );
}
